import { render, staticRenderFns } from "./user-header.vue?vue&type=template&id=7a978570&"
import script from "./user-header.vue?vue&type=script&lang=js&"
export * from "./user-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports